import { render, staticRenderFns } from "./BusinessUnitDetail.vue?vue&type=template&id=cf348446"
import script from "./BusinessUnitDetail.vue?vue&type=script&lang=js"
export * from "./BusinessUnitDetail.vue?vue&type=script&lang=js"
import style0 from "./BusinessUnitDetail.vue?vue&type=style&index=0&id=cf348446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports